//#region src/manager_code_for_scanned_items_mode.ts
var ManagerCodeForScannedItemsMode = /* @__PURE__ */ function(ManagerCodeForScannedItemsMode) {
	ManagerCodeForScannedItemsMode["Never"] = "never";
	ManagerCodeForScannedItemsMode["Removal"] = "removal";
	ManagerCodeForScannedItemsMode["RemovalAndMenuExit"] = "removal-and-menu-exit";
	return ManagerCodeForScannedItemsMode;
}(ManagerCodeForScannedItemsMode || {});
//#endregion
export { ManagerCodeForScannedItemsMode };

//# sourceMappingURL=manager_code_for_scanned_items_mode.js.map